import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=5d1ea6bb&scoped=true&"
import script from "./exhibition.vue?vue&type=script&lang=js&"
export * from "./exhibition.vue?vue&type=script&lang=js&"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=5d1ea6bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ea6bb",
  null
  
)

export default component.exports